export default {
    ja: {
        main_heading: {
            title: '奇岩と光が響き合う\n'+'秋夜の小径',
            subtitle: '',
            description:
                '北陸の名勝 那谷寺（なたでら）と、クリエイティブカンパニーNAKED, INC.（ネイキッド）が手がけるデジタルアートが融合した秋のナイトウォークイベント。幻想的なライトアップや奇岩遊仙境のプロジェクションマッピング、通常非公開エリアの特別公開や九谷焼をテーマにした参加型アートも登場。“石のまち小松”ならではの文化と自然美に出会える、秋だけの特別な夜をお届けします。',
        },
    },
    en: {
        main_heading: {
            title: 'An Autumn Night Path Where Rocks and Light Resonate',
            subtitle: '',
            description:
                'An autumn night walk event where Hokuriku’s scenic Natadera Temple meets the digital art of NAKED, INC.\n' +
                'The program features dreamlike illuminations, projection mapping on Kigan Yusenkyō—a nationally designated scenic spot of unusual rock formations—special access to normally closed areas, and participatory art inspired by Kutani ware.\n' +
                'Experience a one-of-a-kind autumn evening where the culture and natural beauty of Komatsu, the City of Stone, come alive through light and art.',
        },
    },

}